import {
  Component, HostBinding,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-icon-wrapper';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-icon',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmIcon]',
  template: `<i class="app-icon {{iconClass}}" [attr.aria-label]="hint || 'Icon'"></i>
  <span class="sr-only" *ngIf="iconClass">{{caption}} {{appLocale.LABEL_ICON}}</span>
  <label class="app-label" [textContent]="caption" *ngIf="caption"></label>
  `,
  providers: [
    provideAsWidgetRef(IconComponent)
  ],
  exportAs: 'wmIcon',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class IconComponent extends StylableComponent {
  static initializeProps = register('wm-icon');

  public iconclass: any;
  public caption: string;
  public hint: string;
  public iconClass: string;
  @HostBinding('attr.icon-position') iconposition: string;
  @HostBinding('style.fontSize') iconsize: string;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
  override onPropertyChange(key: string, value: any, ov?: any) {
    if (key === 'iconclass') {
      this.iconClass = this.getAttr('iconclass.bind') || value?.startsWith('bind:') ? 'wms wms-link' : value;
    }
    if(key === 'name' && this.getAttr('iconclass.bind')){
      this.iconClass = 'wms wms-link'
    }
    super.onPropertyChange(key, value, ov);
  }
  override get stylerEl(): HTMLElement {
    return this.nativeElement;
  }
}

